var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    fill: "#5865f2",
    fillOpacity: 1,
    rx: 8.304
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0.092,
    d: "M27.966 11.695a19.112 19.112 0 00-4.842-1.522c-.208.377-.452.885-.62 1.288a17.776 17.776 0 00-5.365 0c-.168-.403-.417-.91-.628-1.288-1.7.294-3.326.813-4.845 1.525-3.064 4.63-3.894 9.145-3.479 13.596a19.356 19.356 0 005.938 3.043c.478-.658.904-1.358 1.271-2.095-.7-.265-1.37-.593-2.002-.974.168-.125.332-.255.49-.389 3.862 1.806 8.057 1.806 11.872 0 .161.134.325.264.491.389-.635.382-1.306.71-2.006.976.367.735.792 1.437 1.272 2.095a19.317 19.317 0 005.941-3.045c.487-5.16-.832-9.633-3.488-13.6zM15.922 22.557c-1.159 0-2.11-1.082-2.11-2.4 0-1.318.931-2.402 2.11-2.402 1.18 0 2.13 1.083 2.11 2.402.002 1.318-.93 2.4-2.11 2.4zm7.797 0c-1.16 0-2.11-1.082-2.11-2.4 0-1.318.93-2.402 2.11-2.402 1.18 0 2.13 1.083 2.11 2.402 0 1.318-.93 2.4-2.11 2.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.cb1bef8717a15ab25c615464a15dbe61.svg";
export { ForwardRef as ReactComponent };